var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.0001,
    cy: 37,
    r: 12.7308,
    stroke: "#56179A",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0385 36.7692C58.0385 48.5159 48.5159 58.0385 36.7692 58.0385C25.0226 58.0385 15.5 48.5159 15.5 36.7692C15.5 25.0226 25.0226 15.5 36.7692 15.5C48.5159 15.5 58.0385 25.0226 58.0385 36.7692Z",
    stroke: "#56179A",
    strokeOpacity: 0.42,
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 35.5,
    stroke: "#56179A",
    strokeOpacity: 0.08,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ab6d295655776f583658eb91ab390f6e.svg";
export { ForwardRef as ReactComponent };